import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Button, TextField} from '@mui/material';

export default function InputDialog({ open, closer, fetcher, title, msg, action = () => undefined, maxInput = 255}) {
  
  const [input, setInput] = React.useState('');

  const handleCancel = async() => {
    if(!ValidInput()){
      alert('Some input must be provided');
      return;
    }
    
    setInput('');
    closer();
  }

  const handleConfirm = async() => {
    if(!ValidInput()){
      alert('Some input must be provided');
      return;
    }

    fetcher(input);
    setInput('');
    action();
    closer();
  }

  const ValidInput = () => {
    var result = false;
    result = input.trim().length > 0
    return result;
  }

  return (
    <Dialog 
      open={open} 
      onClose={handleCancel} 
      maxWidth='md'
      fullWidth={true}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {msg}
        </DialogContentText>
        <TextField 
          margin="normal"
          fullWidth
          label="Input"
          id="input"
          name="input"
          autoFocus
          multiline
          inputProps={{
            maxLength: maxInput,
          }}
          value={input}
          onChange={e => setInput(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color='secondary' variant='contained'>Cancel</Button>
        <Button onClick={handleConfirm} variant='contained'>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
}